module.exports = {
  title: 'scrm-base',
  response: {
    data_key: 'data',
    message_key: 'message',
    code_key: 'code',
    code_success_value: '0',
    code_message_map: {}
  },
  request: {
    baseURL: 'http://192.168.2.59:8315/rop-scrm-sso/router',
    // 设置超时时间
    timeout: 180000,
    // 携带凭证
    withCredentials: true,
    // 返回数据类型
    responseType: 'json'
  },
  sign: {
    appKey: '48e5e13229b82c1b4e6e8c96151f0637',
    v: '1.0.0',
    format: 'json',
    source: ''
  },
  secret: 'c24619ed7fef02a0ae16328146bca5f97cc6493957a2137b',

  cdn: 'https://www.xxx.cn/static',

  productCode: 'PC0001',
  loginSource: 'SCRM'
}
